import { Action, TableActions, readPermissions } from "../../../features/roles";
import { TableName } from "../../../tables";

export const stockPermissions = (): TableActions[] => readPermissions().concat([
    { tableName: TableName.STOCK, actions: [Action.SAVE, Action.REMOVE] }
])
